import { KPICard } from '../../../../Components';
import { FileTextOutlined, RiseOutlined, TeamOutlined, UserAddOutlined } from '@ant-design/icons';
import { agencyApis } from '@esg/business-agency';
import { useHttpQuery } from '@esg/framework';
import { dateRangeState, FlexBox } from '@esg/ui';
import { Row } from 'antd';
import React from 'react';
import { useAtom } from "jotai";

const CustomerOverviewContainer = () => {

    const [dateRange] = useAtom(dateRangeState);

    const { data: organizations, isLoading: isGetOverviewOrganization } = useHttpQuery(
        agencyApis.organization.getOverviewOrganization,
        {
            query: {
                startTime: dateRange![0].toISOString(),
                endTime: dateRange![1].toISOString()
            }
        }
    );

    const { data: customers, isLoading: isGetOverviewBranchSubsLoading } = useHttpQuery(
        agencyApis.subscription.getOverviewBranchSubscription,
        {
            query: {
                startTime: dateRange![0].toISOString(),
                endTime: dateRange![1].toISOString()
            }
        }
    );

    const { data: newCustomers, isLoading: isGetOverviewNewBranchSubsLoading } = useHttpQuery(
        agencyApis.subscription.getOverviewBranchSubscription,
        {
            query: {
                startTime: dateRange![0].toISOString(),
                endTime: dateRange![1].toISOString(),
                isNewBranchSubscription: true
            }

        }
    );

    const { data: appointments, isLoading: isGetOverviewAppoientmentLoading } = useHttpQuery(
        agencyApis.appointment.getOverviewAppointment,
        {
            query: {
                startTime: dateRange![0].toISOString(),
                endTime: dateRange![1].toISOString()
            }

        }
    );

    const { data: sales, isLoading: isGetOverviewSaleLoading } = useHttpQuery(
        agencyApis.sale.getOverviewSale,
        {
            query: {
                startTime: dateRange![0].toISOString(),
                endTime: dateRange![1].toISOString()
            }

        }
    );

    const calculateChangePercent = (currentValue: number, previousValue: number): number => {
        if (previousValue === 0) {
            if (currentValue === 0) return 0;
            return 100;
        }

        return ((currentValue - previousValue) / previousValue) * 100;
    };

    return (
        <FlexBox direction='column'>
            <Row gutter={[16, 16]}>
                <KPICard
                    title='Total Organizations'
                    value={organizations?.currentOrganizationCount ?? 0}
                    change={calculateChangePercent(organizations?.currentOrganizationCount!, organizations?.pastOrganizationCount!)}
                    prefix={<TeamOutlined style={{ color: '#13C2C2' }} />}
                    isLoading={isGetOverviewOrganization}
                />
                <KPICard
                    title='Total Active Branches'
                    value={customers?.currentBranchSubscriptionCount ?? 0}
                    change={calculateChangePercent(customers?.currentBranchSubscriptionCount!, customers?.pastBranchSubscriptionCount!)}
                    prefix={<FileTextOutlined style={{ color: '#13C2C2' }} />}
                    isLoading={isGetOverviewBranchSubsLoading}
                />
                <KPICard
                    title='Total New Branches'
                    value={newCustomers?.currentBranchSubscriptionCount ?? 0}
                    change={calculateChangePercent(newCustomers?.currentBranchSubscriptionCount!, newCustomers?.pastBranchSubscriptionCount!)}
                    prefix={<FileTextOutlined style={{ color: '#13C2C2' }} />}
                    isLoading={isGetOverviewNewBranchSubsLoading}
                />
                <KPICard
                    title='Total Appointments'
                    value={appointments?.currentAppointmentCount ?? 0}
                    change={calculateChangePercent(appointments?.currentAppointmentCount!, appointments?.pastAppointmentCount!)}
                    prefix={<UserAddOutlined style={{ color: '#13C2C2' }} />}
                    isLoading={isGetOverviewAppoientmentLoading}
                />
                <KPICard
                    title='Total Bills'
                    value={sales?.currentSaleCount ?? 0}
                    change={calculateChangePercent(sales?.currentSaleCount!, sales?.pastSaleCount!)}
                    prefix={<RiseOutlined style={{ color: '#13C2C2' }} />}
                    isLoading={isGetOverviewSaleLoading}
                />
            </Row>
        </FlexBox>
    );
};

export { CustomerOverviewContainer };

